import { inject } from '@angular/core';
import { type ActivatedRouteSnapshot, Router, type UrlTree } from '@angular/router';
import { catchError, map, type Observable, of } from 'rxjs';

import { type PoolModel } from '../../models/Pool';
import { PoolStatus } from '../../models/Status';
import { PoolService } from '../services/pool.service';

export const activePoolGuard = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
  const poolService: PoolService = inject(PoolService);
  const router = inject(Router);
  const poolId = route.params['poolId'] as string;

  // Try to find contestId in parent routes to redirect back to contest run page
  const contestId = (route.parent?.params['contestId'] ||
    route.parent?.parent?.params['contestId']) as string | undefined;

  return poolService.getPoolByIdOrName(poolId).pipe(
    map((pool: PoolModel) => {
      if (pool?.status === PoolStatus.ACTIVE) {
        return true;
      } else {
        const redirectUrl = contestId ? ['/contests', contestId, 'run'] : ['/'];
        return router.createUrlTree(redirectUrl);
      }
    }),
    catchError(() => {
      const redirectUrl = contestId ? ['/contests', contestId, 'run'] : ['/'];
      return of(router.createUrlTree(redirectUrl));
    }),
  );
};
